import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LockIcon from "@mui/icons-material/Lock";
import { Link } from "react-router-dom";

const CheckoutHeader = () => {
  return (
    <Box
      display="flex"
      height={"60px"}
      alignItems="center"
      sx={{ padding: "12px 25px", backgroundColor: "#F5F3ee" }}
      flexDirection={"row"}
      justifyContent="center" // Center the content horizontally
      position="relative"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        maxWidth={"1440px"}
        alignItems="center"
        sx={{ margin: "0px 12px 0px 12px" }}
        width={"100%"}
      >
        {/* Logo */}
        <Link to="/">
          <img
            height={"25px"}
            src={`${process.env.REACT_APP_IMAGE_FOLDER}/logo_evefant_azul_24f13dfd09.png`}
            alt="Evefant Logo"
          />
        </Link>

        {/* Secure payment section */}
        <Box display="flex" alignItems="center" maxWidth="50%">
          <LockIcon
            sx={{ color: "green", fontSize: "16px", marginRight: "5px" }}
          />
          <Typography
            sx={{
              color: "green",
              fontSize: "14px",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            Pasarela de Pagos Segura
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CheckoutHeader;
